<template>
    <div :class="{ 'form-group': true, 'has-error': any() }">
        <slot></slot>
        <status-label v-if="validate && validation.hasError(field)">
            {{ validation.firstError(field) }}
        </status-label>
        <status-label v-else-if="formError && has(formErrorField)">
            {{ get(formErrorField) }}
        </status-label>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            field: {
                default: ''
            },
            formField: {
                default: ''
            },
            validation: {
                default: null
            },
            formErrors: {
                default: null
            }
        },
        computed: {
            formError() {
                return this.formErrors !== null;
            },
            formErrorField() {
                if (_.trim(this.formField) == '') {
                    return this.field;
                }

                return this.formField;
            },
            validate() {
                return ! _.isNil(this.validation);
            }
        },
        methods: {
            any() {
                if (this.validate && this.validation.hasError(this.field)) {
                    return true;
                }

                if (this.formError && this.has(this.formErrorField)) {
                    return true;
                }

                return false;
            },
            get(field) {
                if (this.formError && this.formErrors.errors[field]) {
                    return this.formErrors.errors[field][0];
                }

                return false;
            },
            has(field) {
                if (this.formError) {
                    return this.formErrors.errors.hasOwnProperty(field);
                }

                return false;
            }
        }
    }
</script>